module.exports = __webpack_public_path__ + "img/bgTitle9.97ca23ac.png";